import { defineStore } from 'pinia'
import type { IStoryblokPageData } from '@/stores/types'

export const useStoryblokStore = defineStore('storyblok', () => {
  const data = ref<IStoryblokPageData>()

  return { data }
})
